import { render, staticRenderFns } from "./FornecedorProfile.vue?vue&type=template&id=dfa12fca"
import script from "./FornecedorProfile.vue?vue&type=script&lang=js"
export * from "./FornecedorProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports